import React, { useContext, useEffect, useState } from "react";
import { models } from "powerbi-client";

//import { PowerBiAuthentication } from "../../../Common/CommonJson";
import axios from "axios";
//import { APICall } from "../../../Helpers/API/APICalls";

import { getPowerBiReport, getReportId } from "../../../Helpers/API/APIEndPoints";
import { PowerBIEmbed } from "powerbi-client-react";
import { PowerBiAuthentication, PowerBiAuthenticationHR } from "../../../Common/CommonJson";
import "./powerBiReport.css";
import { getContext } from "../../../Helpers/Context/Context";
import notify from "../../../Helpers/ToastNotification";
import { LoaderContext } from "../../../Helpers/Context/Context";
import { APICall } from "../../../Helpers/API/APICalls";
import Heading from "../../../Components/Heading/Heading";


const PowerBiReportProjectStatus = () => {
  const [embedUrl, setEmbedUrl] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const [error, setError] = useState("");
  const { RoleId } = getContext();
  const RoleIdArray = RoleId.split(",");
  const { showLoader, hideLoader } = useContext(LoaderContext);

  let reportID ; 
  let workspaceId ;

  const getReportIdforManagement = async()=>{

      const {data} = await APICall(getReportId ,"POST", {})
      
      data.map((ele)=>{
        if(ele.configKey == "PowerBiProjectStatusReportId"){

          let arr=[] ;
          arr.push(ele.configValue);
          const parsedData = JSON.parse(arr[0]);
           reportID = parsedData.reportId;
           workspaceId = parsedData.workspaceId

          

        }
      })

  }

  const fetchEmbedInfo = async () => {
    try {

      let obj;

      if(RoleIdArray.includes("3") || RoleIdArray.includes("2") || RoleIdArray.includes("8")){
           obj = {
            reportId: reportID,
            workspaceId: workspaceId,
          }
      }
      // else if(RoleIdArray.includes("4")){
      //    obj = {
      //     reportId: reportIDHr,
      //     workspaceId: workspaceId,
      //   }
        
      //}
        
      const response = await axios.post(
        getPowerBiReport,
        obj,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`, // Ensure this token is valid
            "Content-Type": "application/json",
          },
        }
      );

      const embedToken = response.data.embedToken.token;
      const embedUrl = response.data.embedUrl;

      
      setEmbedUrl(embedUrl);
      setAccessToken(embedToken);
    } catch (err) {
      console.error("Error fetching embed info:", err);
      setError("Failed to load report.");
    }
  };

  useEffect(() => {
    (async()=>{

      showLoader();
      await getReportIdforManagement();
      await fetchEmbedInfo();
      
      hideLoader();

    })()
    
  }, []);

  if (error) {
    // return <div>{error}</div>;
    notify(1,"Failed to load Report.");
  }

  return (
    <>
      <Heading title={"Project Status Power Bi Report"} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            {embedUrl && accessToken ? (
              <div>
                <PowerBIEmbed
                  embedConfig={{
                    type: "report", // Supported types: report, dashboard, tile, visual, qna, paginated report, and create
                    id: reportID,
                    embedUrl: embedUrl,
                    accessToken: accessToken,
                    tokenType: models.TokenType.Embed, // Use models.TokenType.Aad for SaaS embed
                    settings: {
                      panes: {
                        filters: {
                          expanded: false,
                          visible: false,
                        },
                      },
                      background: models.BackgroundType.Transparent,
                    },
                  }}
                  eventHandlers={
                    new Map([
                      ["loaded", () => console.log("Report loaded")],
                      ["rendered", () => console.log("Report rendered")],
                      [
                        "error",
                        (event) => console.log("Report error", event.detail),
                      ],
                      ["visualClicked", () => console.log("Visual clicked")],
                      [
                        "pageChanged",
                        (event) => console.log("Page changed", event),
                      ],
                    ])
                  }
                  cssClassName="bi-embedded"
                  //  cssClassName={"reportClass"}
                />
                <div className="quick-navigation">
                  {/* quick links navigation here */}
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default PowerBiReportProjectStatus;
